import createVueComponent from '../createVueComponent';
export default createVueComponent('outline', 'brand-gitlab', 'BrandGitlab', [["path",{"d":"M21 14l-9 7l-9 -7l3 -11l3 7h6l3 -7z","key":"svg-0"}]]);